/** *
 * To add more static widgets:
 *  - Implement the StaticComponent in the react-pkg package
 *  - Add the css to the viewer/static-components.scss file
 *  - Add the widget to the is-static-widget.ts file in the utils package
 */

import React from 'react';
import Icon from './icon';
import Image from './image';
import { IContent } from 'vev';

export function StaticComponent({ model }: { model: IContent }) {
  const content = model.content || {};
  switch (model.type) {
    case 'section':
      return null;
    case 'frame':
      return null;
    case 'image':
      return <Image src={content?.src} alt={content?.alt} />;
    case 'text': {
      return React.createElement(model.variablesApplied ? content.tag || 'div' : 'div', {
        dangerouslySetInnerHTML: { __html: content?.text || '' },
      });
    }
    case 'shape':
      return <Icon className="icon" d={content?.shapeId} stretch={content.stretch} />;
    default:
      return null;
  }
}
